import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

import TranscriptBlockContainer from '@layout/TranscriptBlockContainer';
import colors from '@theme/colors';

const Title = styled.h1`
  font-family: Lato, sans-serif !important;
  color: ${colors.PRIMARY};
`;

class TranscriptTitle extends PureComponent {
  render() {
    return (
      <TranscriptBlockContainer.MainContainer>
        <Title>
          {this.props.title} – {moment(this.props.date).format('DD MMMM YYYY')}
        </Title>
      </TranscriptBlockContainer.MainContainer>
    );
  }
}

TranscriptTitle.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};

export default TranscriptTitle;



// WEBPACK FOOTER //
// ./components/molecules/TranscriptTitle.js